import useMountEffect from '@restart/hooks/useMountEffect';
import { RiVideoOnLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import actions from '@/actions';
import LiveViewWindow from '@/components/windows/LiveView';
import { windowsManager } from '@/pages/control-center/Windows';

const Panel = ({ data: [robot] }) => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    windowsManager.show(LiveViewWindow, `${robot.id}/liveView`, { title: 'Live View', color: robot.color }, { robot });
    dispatch(actions.command.resetActivePanels());
  });

  return null;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Live View';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = false;
Command.Icon = RiVideoOnLine;
Command.Panel = Panel;

export default Command;
